
(function() {
  var result = { translations: { "ja": { "i18n": { "duration": { "seconds": "{{ seconds }}\u79D2", "minutes": "{{ minutes }}\u5206", "hours": "{{ hours }}\u6642\u9593", "hoursAndMinutes": "{{ hours }}\u6642\u9593{{ minutes }}\u5206", "days": "{{ days }}\u65E5", "shortForm": { "seconds": "{{ seconds }}\u79D2", "minutes": "{{ minutes }}\u5206", "hours": "{{ hours }}\u6642\u9593", "days": "{{ days }}\u65E5", "hoursAndMinutes": "{{ hours }}\u6642\u9593{{ minutes }}\u5206" } }, "dateTime": { "quarterAndYear": "{{yearNumber}}\u5E74\u7B2C{{quarterNumber}}\u56DB\u534A\u671F" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}\u3001\u5185\u7DDA{{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ja": "static-7.946"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.946",
    "ar-eg": "static-7.946",
    "bg": "static-7.946",
    "bn": "static-7.946",
    "ca-es": "static-7.946",
    "cs": "static-7.946",
    "da": "static-7.946",
    "de": "static-7.946",
    "el": "static-7.946",
    "en-gb": "static-7.946",
    "en": "static-7.946",
    "es-mx": "static-7.946",
    "es": "static-7.946",
    "fi": "static-7.946",
    "fr-ca": "static-7.946",
    "fr": "static-7.946",
    "he-il": "static-7.946",
    "hr": "static-7.946",
    "hu": "static-7.946",
    "id": "static-7.946",
    "it": "static-7.946",
    "ja": "static-7.946",
    "ko": "static-7.946",
    "lt": "static-7.946",
    "ms": "static-7.946",
    "nl": "static-7.946",
    "no": "static-7.946",
    "pl": "static-7.946",
    "pt-br": "static-7.946",
    "pt-pt": "static-7.946",
    "ro": "static-7.946",
    "ru": "static-7.946",
    "sk": "static-7.946",
    "sl": "static-7.946",
    "sv": "static-7.946",
    "th": "static-7.946",
    "tl": "static-7.946",
    "tr": "static-7.946",
    "uk": "static-7.946",
    "vi": "static-7.946",
    "x-pseudo": "static-7.946",
    "zh-cn": "static-7.946",
    "zh-hk": "static-7.946",
    "zh-tw": "static-7.946"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ja', {version: 'static-7.946'}); }
})();


